// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__W9WCM","header":"MergedInvoice_header__1uft-"};